module.exports = __webpack_public_path__ + "img/ky.7cf2c7bc.svg";